import { Image } from "components/Image";
import infoicon from "assets/images/info.png";
import React from "react";
import styles from "./TextModalContent.module.scss";
import { TextModalContentProps } from "models/textModalContent";

export const TextModalContent: React.FC<TextModalContentProps> = ({
  textContent,
  isIconVisible,
}) => {
  return (
    <div className={styles.popupcontainer}>
      <div className={styles.borderpopupcontainer}>
        {isIconVisible && (
          <Image
            source={infoicon}
            altText="info-icon"
            className={styles.infoiconpopup}
          />
        )}
        <p
          className={styles.popupdescription}
          dangerouslySetInnerHTML={{ __html: textContent }}
        ></p>
      </div>
    </div>
  );
};
